import React, { useState } from "react";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useStepNavigate } from "../hooks/useStepNavigate";
import FloatingLabelInput from "../components/form_elements/FloatingLabelInput";
import { showErrorToast, showSuccessToast } from "../components/toasts/ToastService";

const deriveTipus = (total, value) => {
    if (!value) return "nem_kell";
    return Number(total) === 1 ? "teljes_hossz" : "sarok";
};

const Donga = () => {
    const { order, updateOrder } = useOrder();
    const { saveOrder } = useOrderSave();
    const navigate = useStepNavigate();

    const [balTipus, setBalTipus] = useState(() =>
        deriveTipus(order.hmeliorder?.hmeliorder_stave_left_total, order.hmeliorder?.hmeliorder_stave_left_value)
    );
    const [balMeret, setBalMeret] = useState(order.hmeliorder?.hmeliorder_stave_left_value || "");
    const [balOldal, setBalOldal] = useState(
        order.hmeliorder?.hmeliorder_stave_left_in
            ? "belső"
            : order.hmeliorder?.hmeliorder_stave_left_out
            ? "külső"
            : ""
    );
    const [balMegjegyzes, setBalMegjegyzes] = useState(order.hmeliorder?.hmeliorder_stave_left_remark || "");

    const [jobbTipus, setJobbTipus] = useState(() =>
        deriveTipus(order.hmeliorder?.hmeliorder_stave_right_total, order.hmeliorder?.hmeliorder_stave_right_value)
    );
    const [jobbMeret, setJobbMeret] = useState(order.hmeliorder?.hmeliorder_stave_right_value || "");
    const [jobbOldal, setJobbOldal] = useState(
        order.hmeliorder?.hmeliorder_stave_right_in
            ? "belső"
            : order.hmeliorder?.hmeliorder_stave_right_out
            ? "külső"
            : ""
    );
    const [jobbMegjegyzes, setJobbMegjegyzes] = useState(order.hmeliorder?.hmeliorder_stave_right_remark || "");

    const [loading, setLoading] = useState(false);

    const handleNext = async () => {
        try {
            setLoading(true);

            const updatedOrder = {
                ...order,
                hmeliorder: {
                    ...order.hmeliorder,
                    ...(balTipus === "nem_kell"
                        ? {
                              hmeliorder_stave_left_total: 0,
                              hmeliorder_stave_left_value: "",
                              hmeliorder_stave_left_in: 0,
                              hmeliorder_stave_left_out: 0,
                              hmeliorder_stave_left_remark: "",
                          }
                        : {
                              hmeliorder_stave_left_total: balTipus === "teljes_hossz" ? 1 : 0,
                              hmeliorder_stave_left_value: balMeret,
                              hmeliorder_stave_left_in: balOldal === "belső" ? 1 : 0,
                              hmeliorder_stave_left_out: balOldal === "külső" ? 1 : 0,
                              hmeliorder_stave_left_remark: balMegjegyzes,
                          }),
                    ...(jobbTipus === "nem_kell"
                        ? {
                              hmeliorder_stave_right_total: 0,
                              hmeliorder_stave_right_value: "",
                              hmeliorder_stave_right_in: 0,
                              hmeliorder_stave_right_out: 0,
                              hmeliorder_stave_right_remark: "",
                          }
                        : {
                              hmeliorder_stave_right_total: jobbTipus === "teljes_hossz" ? 1 : 0,
                              hmeliorder_stave_right_value: jobbMeret,
                              hmeliorder_stave_right_in: jobbOldal === "belső" ? 1 : 0,
                              hmeliorder_stave_right_out: jobbOldal === "külső" ? 1 : 0,
                              hmeliorder_stave_right_remark: jobbMegjegyzes,
                          }),
                },
            };

            updateOrder(updatedOrder);

            const result = await saveOrder(updatedOrder);
            if (result.success) {
                showSuccessToast("A rendelés sikeresen mentve!");
                navigate("/Gordulo");
            } else {
                showErrorToast("Hiba történt a rendelés mentésekor!");
            }
        } catch (error) {
            console.error("Hiba a rendelés mentésekor:", error);
            showErrorToast("Hiba történt a rendelés mentésekor!");
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (side, type) => {
        if (side === "bal") {
            setBalTipus(type);
            if (type === "nem_kell") {
                setBalMeret("");
                setBalOldal("");
            }
        } else if (side === "jobb") {
            setJobbTipus(type);
            if (type === "nem_kell") {
                setJobbMeret("");
                setJobbOldal("");
            }
        }
    };

    const handleSideSelect = (side, position) => {
        if (side === "bal") {
            setBalOldal((prev) => (prev === position ? "" : position));
        } else if (side === "jobb") {
            setJobbOldal((prev) => (prev === position ? "" : position));
        }
    };

    const handleInputChange = (setter) => (e) => {
        const value = e.target.value.slice(0, 2);
        setter(value);
    };

    const canProceed =
        (balTipus === "nem_kell" || (balTipus && balMeret && balOldal)) &&
        (jobbTipus === "nem_kell" || (jobbTipus && jobbMeret && jobbOldal));

    const gombStilus = (selected, value) => `btn w-100 py-3 px-3 shadow-sm rounded-4 fw-bold ${selected === value ? "btn-primary" : "btn-outline-primary"}`;

    return (
        <TablerLayout title="Adja meg a donga típusát és méretét!">
            <div className="row justify-content-center">
                <div className="col-md-10">
                    <div className="card-body">
                        <div className="row g-4">
                            {/* Bal oldal */}
                            <div className="col-12 col-md-6">
                                <div className="fw-bold mb-3 text-center fs-5">Bal oldal</div>
                                <div className="row g-3 mb-3">
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={gombStilus(balTipus, "sarok")}
                                            onClick={() => handleSelect("bal", "sarok")}
                                        >
                                            Sarok
                                        </button>
                                    </div>
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={gombStilus(balTipus, "teljes_hossz")}
                                            onClick={() => handleSelect("bal", "teljes_hossz")}
                                        >
                                            Teljes hosszában
                                        </button>
                                    </div>
                                </div>
                                <div className="row g-3 mb-3">
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={gombStilus(balOldal, "belső")}
                                            onClick={() => handleSideSelect("bal", "belső")}
                                            disabled={!balTipus || balTipus === "nem_kell"}
                                        >
                                            Belső
                                        </button>
                                    </div>
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={gombStilus(balOldal, "külső")}
                                            onClick={() => handleSideSelect("bal", "külső")}
                                            disabled={!balTipus || balTipus === "nem_kell"}
                                        >
                                            Külső
                                        </button>
                                    </div>
                                </div>
                                {/* Méret input */}
                                <div className="mb-3">
                                    <FloatingLabelInput
                                        label="Méret (milliméterben)"
                                        id="balMeretInput"
                                        name="balMeret"
                                        type="number"
                                        value={balMeret}
                                        onChange={handleInputChange(setBalMeret)}
                                        addon="mm"
                                        fontSize={25}
                                        maxLength={2}
                                        disabled={balTipus === "nem_kell"}
                                    />
                                </div>
                                {/* Megjegyzés input */}
                                <div className="mb-3">
                                    <FloatingLabelInput
                                        label="Megjegyzés"
                                        id="balMegjegyzesInput"
                                        name="balMegjegyzes"
                                        type="text"
                                        value={balMegjegyzes}
                                        onChange={(e) => setBalMegjegyzes(e.target.value)}
                                        fontSize={25}
                                        maxLength={255}
                                    />
                                </div>
                                {/* Nem kell gomb - Bal oldal */}
                                <div className="text-center">
                                    <button
                                        type="button"
                                        className={`btn ${balTipus === "nem_kell" ? "btn-secondary text-white" : "btn-outline-secondary bg-white text-secondary border-secondary"} w-100 py-3 px-3 shadow-sm rounded-4 fw-bold`}
                                        onClick={() => handleSelect("bal", "nem_kell")}
                                    >
                                        Nem kell
                                    </button>
                                </div>
                            </div>

                            {/* Jobb oldal */}
                            <div className="col-12 col-md-6">
                                <div className="fw-bold mb-3 text-center fs-5">Jobb oldal</div>
                                <div className="row g-3 mb-3">
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={gombStilus(jobbTipus, "sarok")}
                                            onClick={() => handleSelect("jobb", "sarok")}
                                        >
                                            Sarok
                                        </button>
                                    </div>
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={gombStilus(jobbTipus, "teljes_hossz")}
                                            onClick={() => handleSelect("jobb", "teljes_hossz")}
                                        >
                                            Teljes hosszában
                                        </button>
                                    </div>
                                </div>
                                <div className="row g-3 mb-3">
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={gombStilus(jobbOldal, "belső")}
                                            onClick={() => handleSideSelect("jobb", "belső")}
                                            disabled={!jobbTipus || jobbTipus === "nem_kell"}
                                        >
                                            Belső
                                        </button>
                                    </div>
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={gombStilus(jobbOldal, "külső")}
                                            onClick={() => handleSideSelect("jobb", "külső")}
                                            disabled={!jobbTipus || jobbTipus === "nem_kell"}
                                        >
                                            Külső
                                        </button>
                                    </div>
                                </div>
                                {/* Méret input */}
                                <div className="mb-3">
                                    <FloatingLabelInput
                                        label="Méret (milliméterben)"
                                        id="jobbMeretInput"
                                        name="jobbMeret"
                                        type="number"
                                        value={jobbMeret}
                                        onChange={handleInputChange(setJobbMeret)}
                                        addon="mm"
                                        fontSize={25}
                                        maxLength={2}
                                        disabled={jobbTipus === "nem_kell"}
                                    />
                                </div>
                                {/* Megjegyzés input */}
                                <div className="mb-3">
                                    <FloatingLabelInput
                                        label="Megjegyzés"
                                        id="jobbMegjegyzesInput"
                                        name="jobbMegjegyzes"
                                        type="text"
                                        value={jobbMegjegyzes}
                                        onChange={(e) => setJobbMegjegyzes(e.target.value)}
                                        fontSize={25}
                                        maxLength={255}
                                    />
                                </div>
                                {/* Nem kell gomb - Jobb oldal */}
                                <div className="text-center">
                                    <button
                                        type="button"
                                        className={`btn ${jobbTipus === "nem_kell" ? "btn-secondary text-white" : "btn-outline-secondary bg-white text-secondary border-secondary"} w-100 py-3 px-3 shadow-sm rounded-4 fw-bold`}
                                        onClick={() => handleSelect("jobb", "nem_kell")}
                                    >
                                        Nem kell
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer d-flex justify-content-between">
                        <StepperNavButton side="left" label="Vissza" onClick={() => navigate("/OrrMerevito")} />
                        <StepperNavButton side="right" label="Tovább" onClick={handleNext} disabled={!canProceed || loading} />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default Donga;
